import React from "react";
import PropTypes from "prop-types";
import Dropdown from "shared/@forms/Dropdown";
import styles from "./SpeakerTypeForm.module.css";

const noop = () => {};

export function SpeakerTypeForm({
  contributorTypes,
  contributorTypeCode,
  onContributorTypeCodeChange,
}) {
  const selectedType =
    contributorTypes.find(
      (type) => type.contributorTypeCode === contributorTypeCode,
    ) || null;

  const contributorTypeOptions = contributorTypes.map(
    (type) => type.contributorType,
  );

  const handleContributorTypeLabelChange = (selectedLabel) => {
    const selected = contributorTypes.find(
      (type) => type.contributorType === selectedLabel,
    );

    if (!selected) {
      return;
    }

    onContributorTypeCodeChange(selected.contributorTypeCode);
  };

  return (
    <section className={styles.card}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <h3 className={styles.title}>Speaker Type</h3>
        </div>

        <div className={styles.divider} />

        <div className={styles.typeSelectWrap}>
          <Dropdown
            className={styles.typeDropdownRoot}
            chevronClassName={styles.typeDropdownChevron}
            chevronOpenClassName={styles.typeDropdownChevronUp}
            value={selectedType?.contributorType || ""}
            options={contributorTypeOptions}
            placeholder="Choose (Default)"
            onChange={handleContributorTypeLabelChange}
            menuAriaLabel="Contributor Type options"
            menuRole="listbox"
            buttonBackgroundColor="#ffffff"
            menuBackgroundColor="#283b4d"
          />
        </div>
      </div>
    </section>
  );
}

SpeakerTypeForm.propTypes = {
  contributorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      contributorTypeCode: PropTypes.string.isRequired,
      contributorType: PropTypes.string.isRequired,
    }),
  ),
  contributorTypeCode: PropTypes.string,
  onContributorTypeCodeChange: PropTypes.func,
};

SpeakerTypeForm.defaultProps = {
  contributorTypes: [],
  contributorTypeCode: "",
  onContributorTypeCodeChange: noop,
};

export default SpeakerTypeForm;
